import React, { useEffect, useRef, useState } from 'react';
// import { reactPlugin } from '../../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { jsonEditorStyles } from '../jsonEditorStyles';
import Button from '@mui/material/Button';
import cn from 'clsx';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import InputLabel from '@mui/material/InputLabel';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormLabel from '@material-ui/core/FormLabel';
import FormGroup from '@material-ui/core/FormGroup';
import useComponentUIHook from './useComponentUIHook';
import useJSONEditorHook from '../useJSONEditorHook';
import { SelectComponent, TextComponent, TooltipComponent } from '../../uiComponents';
import { Radio, RadioGroup, SelectChangeEvent } from '@mui/material';
import { OptionProps } from '../../../view-models';
import { getFlowcharts, getJSONClaims, getNodeData, setJSONClaims } from '../../../store';
import CONSTANTS from '../../../constants/constants';
import DeleteIcon from '@mui/icons-material/Delete';
import ModeEditOutlineSharpIcon from '@mui/icons-material/ModeEditOutlineSharp';
import { cloneDeep } from 'lodash';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import SessionManagement, { sessionFieldsAreValid } from './sessionManagement';
import jsonComponents from '../../../constants/jsonComponents';
import { useSelector, useDispatch } from 'react-redux';
import { init_UserInputPageComponent } from '../init_components';
import AddOrEditSubflowUI from './addOrEditSubflow';
import { ResolverSelector } from './resolverSelector';
import { FieldMapperRow } from './fieldMapperRow';
import TemplatizedFieldComponent, { TemplatizedValue, getTemplatizedValue } from './templatizedFieldComponent';

const styles1 = makeStyles((theme: Theme) =>
  createStyles({
    flexCol: {
      display: 'flex',
      flexDirection: 'column',
    },
    flexColfill: {
      display: 'flex',
      flexDirection: 'column',
      flexBasis: '100%',
      flex: '1',
      padding: '2px',
      overflow: 'hidden',
      '& .inline-tooltip': {
        marginTop: '10px',
      },
    },
    flexRow: {
      display: 'flex',
      flexDirection: 'row',
    },
    attribute: {
      borderBottom: '1px solid grey',
      padding: 10,
    },
    pointer: {
      cursor: 'pointer',
    },
    icon: {
      cursor: 'pointer',
      marginLeft: '0.5rem',
    },
    justifyContent: {
      justifyContent: 'space-between',
    },
    marginRight: { marginRight: '20px' },
    marginLeft: { marginLeft: '20px' },
    displayAttribute: {
      flex: 1,
    },
    actions: {
      width: 90,
    },
  }),
);

interface componentProps {
  componentData: any;
  closeGritComponent: any;
  openSubmitActionFC: any;
  openCustomEmailFC: any;
  setUnsavedChanges: any;
}
const GenerateUserInputPageUI = ({
  componentData,
  closeGritComponent,
  openSubmitActionFC,
  openCustomEmailFC,
  setUnsavedChanges,
}: componentProps) => {
  const { modifiedData, setModifiedData, checkIfSameIgnoringSubFlows, onDeleteSubFlow, modifiedTemplatizations, setModifiedTemplatizations } =
    useComponentUIHook(componentData);
  // for addAttribute
  const configData = jsonComponents.userInputPage;
  const initAttribute = useRef(componentData['attribute']);
  const [claimsList, setClaimsList] = useState<OptionProps[]>([]);
  const [passwordClaim, setPasswordClaim] = useState<any>({
    options: configData.passwordOptions,
    minConstraints: configData.minConstraints,
    length: configData.passwordLength,
  });
  const [modifyIndex, setModifyIndex] = useState<number>(-1);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
  const allClaims = useSelector(getJSONClaims);
  const { setCurrentTabId } = useJSONEditorHook();
  const prefillValueOptions = [
    { label: 'Choose from another attribute', value: 'fromAnotherAttribute' },
    { label: 'Default value', value: 'defaultValue' },
  ];

  const classes1 = jsonEditorStyles();
  const classes = styles1();
  const dispatch = useDispatch();

  useEffect(() => {
    if (Object.keys(allClaims).length > 0) {
      const _temp = Object.keys(allClaims)
        .reduce((acc: OptionProps[], curVal: string) => acc.concat({ label: curVal, value: curVal }), [])
        .sort((a: OptionProps, b: OptionProps) => (a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1));
      setClaimsList(_temp);
    }
    if (allClaims.hasOwnProperty('password')) {
      setPasswordClaim({
        options: allClaims['password']['options'] || configData.passwordOptions,
        minConstraints: allClaims['password']['minConstraints'] || configData.minConstraints,
        length: allClaims['password']['length'] || configData.passwordLength,
      });
    }
  }, [allClaims]);

  const onEditHandler = (index: number) => {
    setModifyIndex(index);
    setModifiedData({
      ...modifiedData,
      attribute: modifiedData['attributes'][index],
    });
  };

  const onDeleteHandler = (index: number) => {
    setModifyIndex(index);
    const _attributes = modifiedData['attributes'].reduce((acc: any[], item: any, ind: number) => {
      return ind === index ? acc : acc.concat(item);
    }, []);
    setModifiedData({
      ...modifiedData,
      attributes: _attributes,
    });
    setModifyIndex(-1);
  };

  const processAttibute = (data: any) => {
    const obj: any = {};
    obj['attributeName'] = data['attributeName'];
    obj['readOnly'] = data['readOnly'];
    obj['prefillValue'] = data['prefillValue'];
    if (data['prefillValue'] === 'fromAnotherAttribute') {
      obj['attributeSource'] = data['attributeSource'] || Object.keys(allClaims)[0];
      obj['required'] = data['required'];
    }
    if (data['prefillValue'] === 'defaultValue') {
      obj['defaultValue'] =
        allClaims[data['attributeName']]['dataType'] === 'boolean'
          ? data['defaultValue'] || 'false'
          : data['defaultValue'] || '';
    }
    if (data['prefillValue'] === 'sessionContext') {
      obj['sessionContext'] = data['sessionContext'];
    }
    if (data['attributeName'] === 'password') {
      obj['repeatField'] = data['repeatField'];
      obj['enforcePassword'] = data['enforcePassword'];
    }
    obj['required'] = data['required'];
    
    return obj;
  };
  const submitData = (data: any, addFormSubmitAction: boolean, subFlowType?: string) => {
    setDisableSubmit(false);
    closeGritComponent(data, modifiedTemplatizations, addFormSubmitAction, subFlowType);
  };

  useEffect(() => {
    const _res: boolean = checkIfSameIgnoringSubFlows(['formSubmitAction']);
    setDisableSubmit(_res ||
      (!sessionFieldsAreValid(modifiedData)));
    setUnsavedChanges(_res);
  }, [modifiedData]);

  return (
    <div>
      <div className={classes1.subHeading}>User Input</div>

      <div>
        <div className={classes.flexRow}>
          <TemplatizedFieldComponent
            modifiedTemplatizations={modifiedTemplatizations}
            setModifiedTemplatizations={setModifiedTemplatizations}
            data={{
              fieldPath: 'contentDefinition',
              label: configData['contentDefinition']['displayName'],
              style: { margin: 1, width: 600 },
              value: getTemplatizedValue(modifiedData['contentDefinition']),
              variant: 'text'
            }}
            changeHandler={(e: TemplatizedValue) => {
              setModifiedData({ ...modifiedData, contentDefinition: { ...e } });
            }}
          />
        </div>
        <div className={cn(classes1.flexRowWrap)}>
          <SelectComponent
            changeHandler={(e: SelectChangeEvent<string>) => {
              const obj = {
                ...modifiedData,
                attribute: {
                  ...modifiedData['attribute'],
                  attributeName: e.target.value,
                  prefillValue: allClaims[e.target.value]['dataType'] === 'string' ? 'none' : 'fromAnotherAttribute',
                },
              };
              if (e.target.value === 'password') {
                obj['attribute']['enforcePassword'] = false;
              } else {
                delete obj['attribute']['enforcePassword'];
              }
              setModifiedData(obj);
            }}
            data={{
              value: modifiedData['attribute']['attributeName'],
              label: 'Select Attribute',
              options: claimsList,
              style: { margin: 1, width: 200 },
            }}
          />
          <FormControlLabel
            sx={{ m: 1 }}
            label="Read Only"
            control={
              <Checkbox
                checked={modifiedData['attribute']['readOnly']}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setModifiedData({
                    ...modifiedData,
                    attribute: { ...modifiedData['attribute'], readOnly: !modifiedData['attribute']['readOnly'] },
                  });
                }}
              />
            }
          />
          <SelectComponent
            changeHandler={(e: SelectChangeEvent<string>) => {
              setModifiedData({
                ...modifiedData,
                attribute: { ...modifiedData['attribute'], prefillValue: e.target.value },
              });
            }}
            data={{
              disabled: modifiedData['attribute']['attributeName'] === '',
              value: modifiedData['attribute']['prefillValue'],
              label: 'Prefill Value',
              style: { margin: 1, width: 200 },
              options:
                modifiedData['attribute']['attributeName'] !== '' &&
                Object.keys(allClaims).length > 0 &&
                allClaims[modifiedData['attribute']['attributeName']]['dataType'] === 'string'
                  ? prefillValueOptions.concat([
                      { label: 'SessionContext', value: 'sessionContext' },
                      { label: 'None', value: 'none' },
                    ])
                  : (modifiedData['attribute']['attributeName'] !== '' &&
                    Object.keys(allClaims).length > 0 &&
                    allClaims[modifiedData['attribute']['attributeName']]['dataType'] === 'dateTime' ?
                    prefillValueOptions.concat([
                      { label: 'None', value: 'none'}
                    ]) : prefillValueOptions),
            }}
          />
          {modifiedData['attribute']['attributeName'] !== '' &&
            modifiedData['attribute']['prefillValue'] === 'fromAnotherAttribute' && (
              <>
                <SelectComponent
                  changeHandler={(e: SelectChangeEvent<string>) => {
                    setModifiedData({
                      ...modifiedData,
                      attribute: { ...modifiedData['attribute'], attributeSource: e.target.value },
                    });
                  }}
                  data={{
                    value: modifiedData['attribute']['attributeSource'] || Object.keys(allClaims)[0],
                    label: 'Attribute Source',
                    options: claimsList,
                    style: { margin: 1, width: 200 },
                  }}
                />
              </>
            )}
          {modifiedData['attribute']['attributeName'] !== '' &&
            modifiedData['attribute']['prefillValue'] === 'defaultValue' && (
              <>
                {allClaims[modifiedData['attribute']['attributeName']]['dataType'] === 'boolean' && (
                  <SelectComponent
                    changeHandler={(e: SelectChangeEvent<string>) => {
                      setModifiedData({
                        ...modifiedData,
                        attribute: { ...modifiedData['attribute'], defaultValue: e.target.value },
                      });
                    }}
                    data={{
                      value: modifiedData['attribute']['defaultValue'] || 'false',
                      label: 'Default Value',
                      options: [
                        { label: 'true', value: 'true' },
                        { label: 'false', value: 'false' },
                      ],
                      style: { margin: 1, width: 200 },
                    }}
                  />
                )}
                {allClaims[modifiedData['attribute']['attributeName']]['dataType'] === 'string' && (
                  <TextComponent
                    changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                      setModifiedData({
                        ...modifiedData,
                        attribute: { ...modifiedData['attribute'], defaultValue: e.target.value },
                      });
                    }}
                    data={{
                      value: modifiedData['attribute']['defaultValue'],
                      label: 'Default Value',
                      style: { margin: 1, width: 200 },
                    }}
                  />
                )}
              </>
            )}
          {modifiedData['attribute']['attributeName'] !== '' &&
            modifiedData['attribute']['prefillValue'] === 'sessionContext' && (
              <div className={classes.flexRow}>
                <ResolverSelector
                  changeHandler={(rValue: string) => {
                    setModifiedData({
                      ...modifiedData,
                      attribute: { ...modifiedData['attribute'], sessionContext: rValue },
                    });
                  }}
                  label="Session Context"
                  value={modifiedData['attribute']['sessionContext'] || CONSTANTS.SESSIONCONTEXT[0]['value']}
                />
                <TooltipComponent
                  title={CONSTANTS.HELPTEXT.SessionContext.header}
                  desc={CONSTANTS.HELPTEXT.SessionContext.description}
                  link={CONSTANTS.HELPTEXT.SessionContext.link}
                />
              </div>
            )}
          {modifiedData['attribute']['attributeName'] !== '' &&
            (!modifiedData['attribute']['readOnly']) && (
              <FormControlLabel
                sx={{ m: 1, width: 200 }}
                label="Required"
                control={
                  <Checkbox
                    checked={modifiedData['attribute']['required']}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      setModifiedData({
                        ...modifiedData,
                        attribute: {
                          ...modifiedData['attribute'],
                          required: !modifiedData['attribute']['required'],
                        },
                      });
                    }}
                  />
                }
              />
            ) 
          }
          {modifiedData['attribute']['attributeName'] === 'password' && (
            <>
              <FormControlLabel
                sx={{ m: 1, width: 350 }}
                label="Repeat the field twice (used for signups)"
                control={
                  <Checkbox
                    checked={modifiedData['attribute']['repeatField']}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      setModifiedData({
                        ...modifiedData,
                        attribute: {
                          ...modifiedData['attribute'],
                          repeatField: !modifiedData['attribute']['repeatField'],
                        },
                      });
                    }}
                  />
                }
              />
              <FormControlLabel
                sx={{ m: 1, width: 200 }}
                label="Enforce Password Complexity"
                control={
                  <Checkbox
                    checked={
                      modifiedData['attribute']['repeatField'] ? true : modifiedData['attribute']?.enforcePassword
                    }
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      setModifiedData({
                        ...modifiedData,
                        attribute: {
                          ...modifiedData['attribute'],
                          enforcePassword: !modifiedData['attribute']?.enforcePassword,
                        },
                      });
                    }}
                  />
                }
              />

              <FormControl sx={{ margin: 1, width: 200 }}>
                <InputLabel id="mutiple-select-label">Select Constraints</InputLabel>
                <Select
                  variant="outlined"
                  labelId="mutiple-select-label"
                  label="Select Constraints"
                  multiple
                  value={passwordClaim['options']}
                  autoWidth
                  size="small"
                  onChange={(e: any) => {
                    setPasswordClaim({ ...passwordClaim, options: e.target.value });
                  }}
                  renderValue={(selected: any) => {
                    if (selected.length === 0) return 'No constraints selected';
                    else if (selected.length === 1) return selected;
                    else return selected.length + ' constraints selected';
                  }}
                >
                  {configData.passwordOptions.map((option: string) => (
                    <MenuItem key={option} value={option}>
                      <ListItemIcon>
                        <Checkbox checked={passwordClaim['options'].includes(option)} />
                      </ListItemIcon>
                      <ListItemText primary={option} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextComponent
                changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                  setPasswordClaim({ ...passwordClaim, minConstraints: e.target.value });
                }}
                data={{
                  value: passwordClaim['minConstraints'],
                  type: 'number',
                  label: 'Min Constaints Required',
                  style: { margin: 1, width: 180 },
                }}
              />
              {passwordClaim['options'].includes('length') && (
                <>
                  <TextComponent
                    changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                      setPasswordClaim({ ...passwordClaim, length: [e.target.value, passwordClaim['length'][1]] });
                    }}
                    data={{
                      value: passwordClaim['length'][0],
                      type: 'number',
                      label: 'Min',
                      style: { margin: 1, width: 90 },
                    }}
                  />
                  <TextComponent
                    changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                      setPasswordClaim({ ...passwordClaim, length: [passwordClaim['length'][0], e.target.value] });
                    }}
                    data={{
                      value: passwordClaim['length'][1],
                      type: 'number',
                      label: 'Max',
                      style: { margin: 1, width: 90 },
                    }}
                  />
                </>
              )}
            </>
          )}
          <div>
            {modifyIndex === -1 && (
              <Button
                type="submit"
                fullWidth
                variant="contained"
                disabled={
                  modifiedData['attribute']['attributeName'].trim() === '' ||
                  (modifiedData['attribute']['attributeName'] === 'password' &&
                    passwordClaim['options'].filter((op: string) => op !== 'length').length <
                      parseInt(passwordClaim['minConstraints'])) ||
                  (modifiedData['attribute']['attributeName'] === 'password' &&
                    parseInt(passwordClaim['minConstraints']) < 0)
                }
                onClick={() => {
                  const _attribute = processAttibute(modifiedData['attribute']);
                  if (_attribute['attributeName'] === 'password') {
                    dispatch(setJSONClaims({ ...allClaims['password'], ...passwordClaim }));
                  }

                  setModifiedData({
                    ...modifiedData,
                    attributes: [...modifiedData['attributes'], _attribute],
                    attribute: initAttribute.current,
                  });
                }}
              >
                Add
              </Button>
            )}
            {modifyIndex >= 0 && (
              <Button
                type="submit"
                fullWidth
                variant="contained"
                disabled={
                  modifiedData['attribute']['attributeName'].trim() === '' ||
                  (modifiedData['attribute']['attributeName'] === 'password' &&
                    passwordClaim['options'].filter((op: string) => op !== 'length').length <
                      parseInt(passwordClaim['minConstraints'])) ||
                  (modifiedData['attribute']['attributeName'] === 'password' &&
                    parseInt(passwordClaim['minConstraints']) < 0)
                }
                onClick={() => {
                  const _attribute = processAttibute(modifiedData['attribute']);
                  if (_attribute['attributeName'] === 'password') {
                    dispatch(setJSONClaims({ ...allClaims['password'], ...passwordClaim }));
                  }
                  const _attributes = cloneDeep(modifiedData['attributes']);
                  _attributes[modifyIndex] = modifiedData['attribute'];
                  setModifiedData({
                    ...modifiedData,
                    attributes: _attributes,
                    attribute: initAttribute.current,
                  });
                  setModifyIndex(-1);
                }}
              >
                Update
              </Button>
            )}
          </div>
        </div>

        <div>
          {modifiedData['attributes'].map((attr: any, index: number) => (
            <div key={index} className={cn(classes.attribute, classes1.flexRow)}>
              <div className={cn(classes1.flexRowWrap, classes.displayAttribute)}>
                <div className={classes.marginRight}>
                  <b>Attribute :</b> {attr['attributeName']}
                </div>
                <div className={classes.marginRight}>
                  <b>ReadOnly :</b> {attr['readOnly'].toString()}
                </div>
                <div className={classes.marginRight}>
                  <b>PrefillValue :</b> {attr['prefillValue']}
                </div>
                {attr['prefillValue'] === 'fromAnotherAttribute' && (
                  <>
                    <div className={classes.marginRight}>
                      <b>Attribute Source :</b> {attr['attributeSource']}
                    </div>
                    <div className={classes.marginRight}>
                      <b>Required :</b> {attr['required'].toString()}
                    </div>
                  </>
                )}
                {attr['prefillValue'] === 'defaultValue' && (
                  <div className={classes.marginRight}>
                    <b>DefaultValue :</b> {attr['defaultValue']}
                  </div>
                )}
                {attr['prefillValue'] === 'sessionContext' && (
                  <div className={classes.marginRight}>
                    <b>SessionContext : </b>
                    {attr['sessionContext']}
                  </div>
                )}
                {attr['attributeName'] === 'password' && (
                  <div className={classes.marginRight}>
                    <b>RepeatField :</b> {attr['repeatField'].toString()}
                  </div>
                )}
                <div>
                  <b>Required : </b> {attr['required']?.toString()}
                </div>
              </div>
              <div className={cn(classes1.flexRow, classes.actions)}>
                <div>
                  <ModeEditOutlineSharpIcon
                    onClick={() => onEditHandler(index)}
                    className={classes.icon}
                    color="primary"
                  />
                </div>
                <div>
                  <DeleteIcon
                    onClick={() => {
                      window.confirm(
                        'Are you sure you want to delete ' + attr['attributeName'] + '? This cannot be undone.',
                      ) && onDeleteHandler(index);
                    }}
                    className={classes.icon}
                    color="error"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        <div>
          <FormControlLabel
            sx={{ m: 0 }}
            label="Validate User's Email"
            control={
              <Checkbox
                checked={modifiedData['validateEmail']}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setModifiedData({ ...modifiedData, validateEmail: !modifiedData['validateEmail'] });
                }}
              />
            }
          />
        </div>
        {modifiedData['validateEmail'] && (
          <div>
            <div>
              <FormControl>
                <RadioGroup
                  row
                  value={modifiedData['email']['valEmailType']}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setModifiedData({
                      ...modifiedData,
                      email: { ...modifiedData['email'], valEmailType: e.target.value },
                    });
                  }}
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                >
                  <FormControlLabel value="newEmail" control={<Radio />} label="Allow user to input a new email " />
                  <FormControlLabel
                    value="valPrevEmail"
                    control={<Radio />}
                    label="Validate a previously entered email"
                  />
                </RadioGroup>
              </FormControl>
            </div>
            {modifiedData['email']['valEmailType'] === 'newEmail' && (
              <div>
                <SelectComponent
                  changeHandler={(e: SelectChangeEvent<string>) => {
                    setModifiedData({
                      ...modifiedData,
                      email: {
                        ...modifiedData['email'],
                        newEmail: { ...modifiedData['email']['newEmail'], attributeSource: e.target.value },
                      },
                    });
                  }}
                  data={{
                    value: modifiedData['email']['newEmail']['attributeSource'],
                    label: 'Source Attribute',
                    options: claimsList,
                  }}
                />
                <FormControlLabel
                  sx={{ m: 0 }}
                  label="Prefill Value"
                  control={
                    <Checkbox
                      checked={modifiedData['email']['newEmail']['prefillValue']}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        setModifiedData({
                          ...modifiedData,
                          email: {
                            ...modifiedData['email'],
                            newEmail: {
                              ...modifiedData['email']['newEmail'],
                              prefillValue: !modifiedData['email']['newEmail']['prefillValue'],
                            },
                          },
                        });
                      }}
                    />
                  }
                />
              </div>
            )}
            {modifiedData['email']['valEmailType'] === 'valPrevEmail' && (
              <div>
                <FieldMapperRow
                  rowData={modifiedData['email']['valPrevEmail']}
                  writeback={(rowData: any) => {
                    setModifiedData({
                      ...modifiedData,
                      email: {
                        ...modifiedData['email'],
                        valPrevEmail: rowData,
                      },
                    });
                  }}
                  claimsList={claimsList}
                  allClaims={allClaims}
                  enabledSources={['claim', 'resolver']}
                  precursorFields={[
                    {
                      fieldName: 'emailAttribute',
                      fieldType: 'select',
                      fieldData: {
                        label: 'Email Claim',
                        options: claimsList.filter((clm) => {
                          return allClaims[clm.value].dataType === 'string';
                        }),
                        value: modifiedData['email']['valPrevEmail']['emailAttribute']
                          ? modifiedData['email']['valPrevEmail']['emailAttribute']
                          : '',
                      },
                    },
                  ]}
                  postFields={[
                    {
                      fieldName: 'editEmail',
                      fieldType: 'checkbox',
                      fieldData: {
                        label: 'Allow Editing',
                      },
                    },
                  ]}
                  sourceTypeFieldName="sourceType"
                  sourceTypeFieldLabel="Fill Email From"
                  sourceFieldName="emailSource"
                  sourceFieldLabels={{ claim: 'Source Claim', resolver: 'Session Context' }}
                />
                {/*<SelectComponent
                  changeHandler={(e: SelectChangeEvent<string>) => {
                    setModifiedData({
                      ...modifiedData,
                      email: {
                        ...modifiedData['email'],
                        valPrevEmail: { ...modifiedData['email']['valPrevEmail'], emailAttribute: e.target.value },
                      },
                    });
                  }}
                  data={{
                    value: modifiedData['email']['valPrevEmail']['emailAttribute'],
                    label: 'Email Attribute',
                    options: claimsList,
                  }}
                />
                <FormControlLabel
                  sx={{ m: 0 }}
                  label="Edit Email"
                  control={
                    <Checkbox
                      checked={modifiedData['email']['valPrevEmail']['editEmail']}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        setModifiedData({
                          ...modifiedData,
                          email: {
                            ...modifiedData['email'],
                            valPrevEmail: {
                              ...modifiedData['email']['valPrevEmail'],
                              editEmail: !modifiedData['email']['valPrevEmail']['editEmail'],
                            },
                          },
                        });
                      }}
                    />
                  }
                />*/}
              </div>
            )}
            <TextComponent
              changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                setModifiedData({
                  ...modifiedData,
                  email: {
                    ...modifiedData['email'],
                    expiryTime: e.target.value,
                  },
                });
              }}
              data={{
                value: '5' /*modifiedData['email']['expiryTime']*/,
                type: 'number',
                label: 'Expiry Time (in mins)',
                disabled: true,
              }}
            />
            <AddOrEditSubflowUI
              modifiedData={modifiedData}
              submitData={(modifiedData: any, csf: boolean, subflowType?: string) =>
                submitData(cloneDeep(modifiedData), csf, subflowType)
              }
              openSubFlowFC={openCustomEmailFC}
              setCurrentTabId={setCurrentTabId}
              onDeleteSubFlow={onDeleteSubFlow}
              subFlowType="emailVerificationSendAction"
              subFlowDisplayName="custom verification email"
              disableSubmit={disableSubmit}
            />
          </div>
        )}
        {configData.sessionManagement && (
          <SessionManagement
            modifiedData={modifiedData}
            changeHandler={(data: any) => setModifiedData(data)}
            sessionTypes={configData.sessionTypes}
          />
        )}
        <div>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            onClick={() => {
              submitData(cloneDeep(modifiedData), false);
            }}
            disabled={disableSubmit}
          >
            Save
          </Button>
        </div>
      </div>
      <div>
        <AddOrEditSubflowUI
          modifiedData={modifiedData}
          submitData={(modifiedData: any, csf: boolean, subflowType?: string) =>
            submitData(cloneDeep(modifiedData), csf, subflowType)
          }
          openSubFlowFC={openSubmitActionFC}
          setCurrentTabId={setCurrentTabId}
          onDeleteSubFlow={onDeleteSubFlow}
          subFlowType="formSubmitAction"
          subFlowDisplayName="submit action"
          disableSubmit={disableSubmit}
        />
      </div>
    </div>
  );
};
// export default withAITracking(reactPlugin, GenerateUserInputPageUI);
export default GenerateUserInputPageUI;
